export const desc = (a: Record<string, any> = {}, b: Record<string, any> = {}, orderBy: string) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }

  if (b[orderBy] > a[orderBy]) {
    return 1;
  }

  return 0;
};
